import { Injectable } from '@angular/core'
import { InfoDialogComponent, InfoDialogParams } from './info-dialog.component'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'

@Injectable()
export class InfoDialogService {
  constructor(private dialog: MatDialog) {}

  public open(data?: InfoDialogParams, config?: MatDialogConfig) {
    const defaultData = {
      title: $localize`Info`,
      body: '',
      closeText: $localize`Close`,
    }

    const defaultConfig: MatDialogConfig = {
      width: '500px',
      height: 'auto',
      data: { ...defaultData, ...data },
      panelClass: ['fixed-modal'],
    }

    return this.dialog.open(InfoDialogComponent, { ...defaultConfig, ...config }).afterClosed()
  }
}
